import updateCloudIcon from "./update-cloud-icon.svg"
import noUpdateCloudIcon from "./no-update-cloud-icon.svg"

export const iconsList = {
  updateCloudIcon,
  noUpdateCloudIcon,
}
